import logo from './logo.svg';
import './App.css';
import Login from './Login'
import CountType from './Count';
import React, { useState } from 'react';

function App() {

  const [loggedIn, setLoggedIn] = useState(false);


  const transitionToAuthenticated = (userIdentity) => {
    if(userIdentity) {
      setLoggedIn(true);
    } else {
      transitionToUnauthenticated()
    }
  };

  const transitionToUnauthenticated = (error) => {
    setLoggedIn(false);
    if(error) {
      console.log(error) //TODO handle
    }
  };

  return (
    <div className="App min-h-screen flex items-center justify-center">
      <div className={"Login" + (loggedIn ? " absolute top-4 right-4" : " border border-gray-300 rounded-lg p-8 shadow-md") }>
        <Login loggedIn={transitionToAuthenticated} loggedOut={transitionToUnauthenticated} />
      </div>
      
      { loggedIn && (
        <CountType></CountType>
      )}

    </div>
  );
}

export default App;
